export function LoadingScreen() {
  return (
    <div style={{
      minHeight: '100vh', display: 'flex', alignItems: 'center',
      justifyContent: 'center', background: '#FAF6EF',
    }}>
      <div style={{ textAlign: 'center' }}>
        <div style={{
          width: 40, height: 40, borderRadius: 10, background: '#0F7C6C',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          font: '700 16px Inter,sans-serif', color: '#fff', margin: '0 auto 14px',
        }}>
          DT
        </div>
        <div style={{ font: '400 13px Inter,sans-serif', color: 'rgba(27,42,74,0.5)' }}>
          Loading…
        </div>
      </div>
    </div>
  )
}
